import { ImageOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "../ui/card";

export const CarCutterWebPlayerFallback = () => {
  const { t } = useTranslation("masterdata");

  return (
    <>
      <Card className="hidden h-full min-h-60 xl:flex">
        <CardContent className="text-muted-foreground flex flex-1 flex-col items-center justify-center gap-2 text-center">
          <ImageOff className="h-8 w-8 opacity-60" aria-hidden />
          <p className="text-foreground text-sm font-medium">{t("VehicleMediaUnavailableTitle")}</p>
          <p className="text-xs">{t("VehicleMediaUnavailableDescription")}</p>
        </CardContent>
      </Card>
      <Card className="flex xl:hidden">
        <CardContent className="text-muted-foreground flex items-center gap-2 text-sm">
          <ImageOff className="h-4 w-4 shrink-0 opacity-60" aria-hidden />
          <span>{t("VehicleMediaUnavailableTitle")}</span>
        </CardContent>
      </Card>
    </>
  );
};
